import header from "./attic-cozy-interior-design.jpg";
import section1 from "./businessman-signing-agreement-document.jpg";
import section2 from "./modern-frame-cabin-interior.jpg";
import section3 from "./empty-chairs-tables.jpg";
import section4 from "./residential-building-against-clear-blue-sky.jpg";
import section5 from "./living-room-with-white-railing.jpg";
import section6 from "./spacious-room-with-various-areas.jpg";
import section7 from "./low-angle-view-couple-standing-balcony.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
